// helper function - recives a type and payload, return back an obj so we dont need to type oout the namr of the keys
export const createAction = (type, payload) => ({ type, payload });
